import { createAction } from 'redux-actions'
import { RESET_PASSWORD, RESET_PASSWORD_SUCCESS } from './constants'

export const resetPassword = createAction(RESET_PASSWORD)
export const resetPasswordSuccess = createAction(RESET_PASSWORD_SUCCESS)
